import React from 'react';
import Typist from 'react-typist-component';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import coverImage from '../assets/images/cover.jpeg'
import coverImagePlaceholder from '../assets/images/cover-min.jpeg'
import './Cover.sass'
import SNSButtons from "./SNSButtons";
import {useMediaQuery, useTheme} from "@mui/material";

function Cover() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <div className={'cover'}>
            <div className={isMobile ? 'cover__full' : 'cover__left'}>
                <LazyLoadImage
                    alt={'background of ocean view taken at a hotel in puerto rico'}
                    src={coverImage}
                    placeholderSrc={coverImagePlaceholder}
                    className={isMobile ? 'cover__full__img' : 'cover__left__img'}
                />
            </div>

            <div className={isMobile ? 'cover__full_text' : "cover__right"}>
                <div className={isMobile ? 'cover__text_mobile' : 'cover__text'}>
                    <h1 className={isMobile ? 'cover__text__name_mobile' : 'cover__text__name'}>Eurey Noguchi</h1>
                    <h2 className={isMobile ? 'cover__text__subtitle_mobile' : 'cover__text__subtitle'}>UI/UX Designer @ Columbia University</h2>
                    <h2 className={isMobile ? 'cover__text_typing_mobile' : "cover__text_typing"}>
                        <Typist cursor={<span className='cursor'>|</span>}>
                            Designing <span className={`cover__emphasis ${isMobile && 'cover__emphasis_mobile'}`}>Innovation</span>
                            <Typist.Delay ms={300} />
                            <Typist.Backspace count={20} delay={500}/>
                            I am a {["Designer", "Developer", "Digital Artist"]
                                .map(word => ([
                                    <span className={`cover__emphasis ${isMobile && 'cover__emphasis_mobile'}`}>{word}</span>,
                                    <Typist.Delay ms={300} />,
                                    <Typist.Backspace count={word.length} delay={500}/>
                                ]))}
                            <Typist.Backspace count={7} />
                            Engineering <span className={`cover__emphasis ${isMobile && 'cover__emphasis_mobile'}`}>Usefulness & Usability</span>
                        </Typist>
                    </h2>

                    <SNSButtons spacing={isMobile ? '1rem' : '2rem'} />
                </div>
            </div>

        </div>
    );
}

export default Cover;